// tariff plan keys, order of elements gives the priority
export const tariffPlanKeys = {
	MOBILE: [
		'TARIFF_PACKAGE',
		'TARIFF_PACKAGE_NAMA',
		'DATA_TARIFF',
		'DATA_TARIFF_SB',
		'DATA_TARIFF_SB_BUSINESS',
		'DATA_TARIFF_NSB',
		'DATA_TARIFF_NSB_BUSINESS',
		'DATA_TARIFF_NSB_SHIFT',
		'DATA_TARIFF_SAHL',
		'DATA_TARIFF_SHIFT',
		'DATA_TARIFF_SB_BUSINESS_AAMALI',
		'DATA_PROVISIOINING',
		'DATA_PROVISIOINING_NSB',
		'DATA_PROVISIOINING_BUSINESS',
		'DATA_PROVISIOINING_BUSINESS_NSB',
		'TARIFF_MOBILE_BUSINESS_DATA',
	],
	FIX: [
		'TARIFF_PACKAGE',
		'TARIFF_PACKAGE_NAMA',
		'PSTN_TARIFF_CONSUMER',
		'PSTN_Supplementary',
		'TARIFF_MOBILE_BUSINESS_DATA',
	],
	INTERNET: [
		'TARIFF_PACKAGE',
		'TARIFF_PACKAGE_NAMA',
		'DATA_TARIFF',
		'DATA_TARIFF_SB',
		'DATA_TARIFF_SB_BUSINESS',
		'DATA_TARIFF_NSB',
		'DATA_TARIFF_NSB_BUSINESS',
		'DATA_TARIFF_NSB_SHIFT',
		'DATA_TARIFF_SAHL',
		'DATA_TARIFF_SHIFT',
		'DATA_TARIFF_SB_BUSINESS_AAMALI',
		'DATA_PROVISIOINING',
		'DATA_PROVISIOINING_NSB',
		'DATA_PROVISIOINING_BUSINESS',
		'DATA_PROVISIOINING_BUSINESS_NSB',
		'TARIFF_MOBILE_BUSINESS_DATA',
	],
};

export const tariffs = ['Nama Professional', 'Nama 2022'];
